import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { useAppSelector } from 'shared/lib/redux';

export interface AvatarState {
  avatarConfig: unknown;
}

const initialState: AvatarState = {
  avatarConfig: null,
};

export const avatarSlice = createSlice({
  name: 'avatar',
  initialState,
  reducers: {
    saveAvatar: (state, action: PayloadAction<unknown>) => {
      state.avatarConfig = action.payload;
    },
  },
});

export const { saveAvatar } = avatarSlice.actions;

export const useAvatarConfigSelector = () =>
  useAppSelector((state) => state.avatar);

export const avatarReducer = avatarSlice.reducer;
